import { useState } from "react";
import { Pencil, Check, X } from "lucide-react";

export const EditableTitle = ({ widgetKey, title, onSave, className = "", as: Tag = "h3" }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(title);
  const [saving, setSaving] = useState(false);

  const start = () => { setValue(title); setEditing(true); };
  const save = async () => {
    const v = value.trim();
    if (!v || v === title) { setEditing(false); return; }
    setSaving(true);
    const ok = await onSave(widgetKey, v);
    setSaving(false);
    if (ok) setEditing(false);
  };

  if (editing) {
    return (
      <div className="flex items-center gap-1.5 min-w-0" data-testid={`widget-title-editor-${widgetKey}`}>
        <input autoFocus value={value} maxLength={80} disabled={saving}
               onChange={(e) => setValue(e.target.value)}
               onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setEditing(false); }}
               className="h-8 px-2 rounded-md border border-emerald-500 text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-emerald-200 min-w-0 flex-1"
               data-testid={`widget-title-input-${widgetKey}`} />
        <button onClick={save} disabled={saving} className="p-1.5 rounded hover:bg-emerald-50 text-emerald-700"
                aria-label="Kaydet" data-testid={`widget-title-save-${widgetKey}`}>
          <Check className="h-4 w-4" />
        </button>
        <button onClick={() => setEditing(false)} className="p-1.5 rounded hover:bg-slate-100 text-slate-500"
                aria-label="Vazgeç" data-testid={`widget-title-cancel-${widgetKey}`}>
          <X className="h-4 w-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="group flex items-center gap-1.5 min-w-0">
      <Tag className={className} data-testid={`widget-title-${widgetKey}`}>{title}</Tag>
      <button onClick={start} className="p-1 rounded text-slate-400 hover:text-emerald-700 hover:bg-slate-100 transition-colors"
              aria-label="Başlığı düzenle" title="Başlığı düzenle" data-testid={`widget-title-edit-${widgetKey}`}>
        <Pencil className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
